import { path } from '../../Paths';
import { requestMethods } from '../../../../Constants/requestMethods';
import { toJSON } from '../../../../Utils';
import { requestFactory } from '../../RequestFactory';

export const getMembers = () => {
    const url = path.create().getMembers();

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const addMember = data => {
    const url = path.create().addMember();

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toJSON(data),
    };

    return requestFactory.createRequest(requestConfig);
};

export const updateMember = (id, data) => {
    const url = path.create().updateMember(id);

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toJSON(data),
    };

    return requestFactory.createRequest(requestConfig);
};

export const deleteMember = memberId => {
    const url = path.create().deleteMember(memberId);

    const requestConfig = {
        url,
        method: requestMethods.DELETE,
    };

    return requestFactory.createRequest(requestConfig);
};

export const addPlansToMember = (id, plans) => {
    const url = path.create().addMembershipPlanToMember(id);

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toJSON(plans),
    };

    return requestFactory.createRequest(requestConfig);
};

export const updateMembersMembershipPlan = (memberId, planMemberId, planData) => {
    const url = path.create().updateMembersMebershipPlan(memberId, planMemberId);

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toJSON(planData),
    };

    return requestFactory.createRequest(requestConfig);
};

export const getMembersBirthdaysByDateRange = (start, end) => {
    const url = path.create().getMembersBirthdaysByDateRange(start, end);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const inviteMemberByEmail = data => {
    const url = path.create().inviteMemberByEmail();

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toJSON(data),
    };

    return requestFactory.createRequest(requestConfig);
};

export const getWaitingMembers = () => {
    const url = path.create().getWaitingMembers();

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const assignClassesToPlan = (planId, data) => {
    const url = path.create().assignClassesToPlans(planId);

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: { series_ids: data },
    };

    return requestFactory.createRequest(requestConfig);
};

export const getClassesForPlans = () => {
    const url = path.create().getClassesForPlans();

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const resendInvitation = memberId => {
    const url = path.create().resendInvitation(memberId);

    const requestConfig = {
        url,
        method: requestMethods.POST,
    };

    return requestFactory.createRequest(requestConfig);
};

export const updateMemberStatus = (memberId, data) => {
    const url = path.create().updateStatus(memberId);

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toJSON(data),
    };

    return requestFactory.createRequest(requestConfig);
};



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/API/MembersApi/membersRequestConfigs.js